<template>
   <div class="modal" v-show="show">
    <div class="modal-wrapper">
      <div class="modal-container">
            <div class="modal-header">¡Entrega de paquete!</div>
            <div class="modal-body">
               <p class="signature-title">Firma de recibido: <vs-button @click="clear" color="primary" type="flat">Limpiar</vs-button></p>
               <vueSignature :key="packageId" ref="signature" :sigOption="option" :w="'100%'" :h="'150px'"></vueSignature> 
               <br>
               <p>¿Como calificas nuestro servicio?</p><br/>
               <div class="option-stars">
                    <template v-for="star in [1,2,3,4,5]">
                        <feather :key="star" :class="{'active': star <= score}" type="star" @click="userSurveyClicked(star)"></feather>
                    </template>
               </div>
               <p class="error-survey">{{ message }}</p>
            </div>
            <div class="modal-footer">
                <vs-button color="danger" type="border" icon="block" @click="closeModal()">Cancelar</vs-button>
                <vs-button  :disabled="confirmStatus" 
                    id="btnConfirm" color="success" @click="updatePackageStatus()" type="border" icon="check" class="vs-con-loading__container">Enviar</vs-button>
            </div>  
      </div>
    </div>
  </div>
</template>
<script>
import {helper} from '@/helpers/utils'
import vueSignature from "vue-signature";
import PackageDataService from "@/services/PackageDataService";
export default {
  name: 'ModalPackageStatus',
  mixins: [helper],
  components: { vueSignature },
  props: {
    show: { type: Boolean, required: true },
    packID: { type: String, required: true },
    customer:{ required: true },
    selected: { type: Object, default: () => {} },
    packIDs: { type: Array, default: () => [] },
    modeUdpdate: { type: Boolean, default: false },
  },
  data() {
    return {
      active: false,
      newStatus: this.selected,
      packageId: this.packID,
      confirmStatus: false,
      notify: false,
      status: [],
      score: 0,
      customerId: this.customer,
      option:{
            penColor:"rgb(0, 0, 0)",
            backgroundColor:"rgb(240, 240, 240)"
        },
        message: ""
    }
  },
  watch: {
    packID () {
      this.packageId = this.packID
    },
    customer (val) {
        this.customerId = val
    }

  },
  methods: {
    clear() {
        this.score = 0;
        this.$refs.signature.clear()
    },
    userSurveyClicked (score) {
        this.score = score
    },
    closeModal () {
        this.clear();
        this.$emit('modal-event', { status: "closed", active: false})
    },
    confirmButton() {
      this.$emit('confirm-modal', this.selected, true)
    },
    updatePackageStatus() {
        
        if(this.$refs.signature.isEmpty() || this.score == 0) {
            this.message = "Favor completar los preguntas para continuar.";
            return false;
        }
        this.message = "";
        const that = this
        that.loadingProgress ('#btnConfirm')
        that.confirmStatus = true
        PackageDataService.saveUserFeedback({
            cu01Id: this.customerId,
            pkg01Id: this.packageId,
            answer: this.score,
            signature: this.$refs.signature.save()
        })
        .then(response => {
                console.log(response)
                that.confirmStatus = false
                this.clear();
                that.$vs.loading.close('#btnConfirm .con-vs-loading')
                that.$emit('modal-event', { message: response, status:"confirmed", response: this.newStatus, error: false, active: false})
        })
        .catch(e => {
            console.log(e)
            that.confirmStatus = false
            that.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
            that.$emit('modal-event', { message: e, status:"confirmed", error: true, active: false})
        });
    },
  }
}
</script>
